import primaryComponents from "../../primaryComponents";
import Icon from "../../../assets/icons";
import { motion } from "framer-motion";
import AddMultipleSuppliersLogic from "./AddMultipleSuppliersLogic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { One } from "../../../assets/svgIcons";

const AddMultipleSuppliers = ({
  closeWidget,
  handleFetchSuppliers = () => {},
}) => {
  const { isUploadingFile, inputRef, handleSupplierUpload } =
    AddMultipleSuppliersLogic({ closeWidget, handleFetchSuppliers });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
      className="m-4"
    >
      <primaryComponents.Button
        classNames="btn btn--outline"
        onClick={() => closeWidget()}
      >
        <FontAwesomeIcon
          icon="angle-left"
          className="mr-3"
          style={{ fontSize: "18px" }}
        />
        <span>Back</span>
      </primaryComponents.Button>
      <div className={globalStyles.pageColumnGaps}>
        <div>
          <h5 className="mt-3">Migrate Your Suppliers</h5>
          <p style={{ display: "none" }}>
            Upload your bulk supplier file here:
          </p>
          <input
            style={{ display: "none" }}
            type="file"
            name="suppliers"
            id="suppliers"
            onChange={handleSupplierUpload}
            ref={inputRef}
            accept=".csv"
          />
        </div>
        <div>
          <hr />
          <p className="small-text-size">
            Step-by-Step Guide for Migrating Your Suppliers to Your Lumi
            Business Store.
          </p>
          <hr />
          <div
            className={globalStyles.pageColumnGaps}
            style={{
              maxWidth: "100%",
              paddingLeft: "70px",
              backgroundColor: "#FAFAFA",
              minHeight: "100%",
              marginTop: "-8px",
              marginBottom: "-8px",
            }}
          >
            <div className="d-flex mt-3" style={{ gap: "4px" }}>
              <One />
              <p className="smallest-text-size dark--text mt-1 p-1">
                <b>Download the sample spreadsheet: </b> Start by downloading
                the sample spreadsheet provided here. This spreadsheet will
                serve as a template for organizing your supplier data. <br />
                <a
                  href={
                    process.env.REACT_APP_SUPPLIER_BATCH_UPLOAD_DOWNLOAD_URL ||
                    "https://enlumi-public-assets.s3.eu-west-2.amazonaws.com/upload_suppliers.csv"
                  }
                  className="purple--text smallest-text-size"
                  style={{ textDecoration: "underline" }}
                >
                  Click here to download template
                </a>
              </p>
            </div>
          </div>
          <hr />
        </div>

        <primaryComponents.Button
          isLoading={isUploadingFile}
          classNames={"btn btn--primary container"}
          loadingText="Uploading..."
          onClick={() => inputRef.current.click()}
        >
          <img className="mr-2" src={Icon.upload} alt="" />
          Upload .CSV File
        </primaryComponents.Button>
      </div>
    </motion.div>
  );
};

export default AddMultipleSuppliers;
